import {User} from "../../types/user/user";

export function isSuperuser(profile: User | undefined): boolean {
    return profile?.company.name === "SUPERUSER";
}
